import { unitLengths as s, oldOdiTaxonomyLengths as o } from "./unitLengths.mjs";
const t = s, c = o, e = {
  px: "1px"
  // NO MATCH - size.s1 (defined in rem)
}, n = {
  ...t,
  ...e,
  ...c
}, a = n;
export {
  a as default,
  c as oldOdiSpaces,
  e as specialSpaces,
  t as unitSpaces
};
